import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    DateTimeColumn,
  } = columns(data);

  return [
    {
      Header: 'History',
      columns: [
        new TextColumn('Operator', 'operator'),
        new TextColumn('IMPC', 'impc'),
        new DateTimeColumn('When', 'when'),
        new NonZeroNumberColumn('Adjustment', 'adjustment'),
        new TextColumn('User', 'lastUpdateUser'),
        new NonZeroNumberColumn('ID', 'id'),
        new TextColumn('Status', 'status'),
        new TextColumn('Comments', 'comment'),
        new DateTimeColumn('Last updated', 'lastUpdateDate'),
      ],
    },
  ];
};
